import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UofTMississauga = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Toronto – Mississauga (UTM)"
      universityShortName="UTM"
      slug="university-of-toronto-mississauga"
      seoTitle="UTM Study Rooms | University of Toronto Mississauga Study Guide"
      seoDescription="Complete guide to study rooms at UTM. Find library study spaces, Maanjiwe Nendamowinan, Deerfield Hall. Plus free 24/7 online study room alternative."
      seoKeywords="utm study rooms, university of toronto mississauga library, utm library study rooms, maanjiwe nendamowinan, deerfield hall, utm study spaces"
      canonicalUrl="/study-room/university-of-toronto-mississauga/"
      heroDescription="A comprehensive guide to study rooms and spaces at U of T Mississauga, including the library, Maanjiwe Nendamowinan, and Deerfield Hall."
      libraryWebsiteUrl="https://library.utm.utoronto.ca/"
      libraryWebsiteName="UTM Library"
      studySpaces={[
        {
          name: "UTM Library",
          features: "Provides individual and group study rooms; booking is required and rooms often face the windows overlooking the campus.",
          feedback: "Students complain that reserved rooms are sometimes occupied by 'squatters' who refuse to leave and that reservations must be made well in advance."
        },
        {
          name: "Deerfield Hall",
          features: "New LEED-certified building with bright atriums and numerous open study areas.",
          feedback: "Spaces are open and airy; however, popular areas near windows fill up quickly."
        },
        {
          name: "Maanjiwe Nendamowinan",
          features: "Adds 500 study spaces, active learning classrooms and event space. Modern LEED-certified building with technology-rich environments.",
          feedback: "Highly rated for modern amenities and sustainability features."
        },
        {
          name: "Instructional Building (IB), Kaneff Centre",
          features: "Offer study nooks and classrooms that become quiet study areas in evenings.",
          feedback: "Some spaces are dated (e.g., Spigel Hall) and lighting can be dim."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            UTM's <strong>Maanjiwe Nendamowinan</strong> is a modern dream for group projects—it provides 500 new study seats, technology-rich classrooms and sustainability features.
          </p>
          <p className="mb-4">
            If you crave sunlight, grab a seat in <strong>Deerfield Hall's</strong> atrium or by the large windows and plan your next presentation. For focused study, book a library room early, but arrive promptly to avoid dealing with occupants who ignore reservation schedules.
          </p>
          <p>
            During crunch time, the campus becomes crowded; in those cases, exploring lesser-known corners like IB's lounges or late-night classrooms can provide the peace needed to finish an assignment.
          </p>
        </>
      }
      summaryTips={[
        "Book library rooms early: UTM study rooms are competitive, especially during exam periods. Reserve as soon as booking opens.",
        "Arrive on time: If you book a room, arrive promptly. Some students report issues with 'squatters' not leaving when reservations start.",
        "Explore Maanjiwe Nendamowinan: The newest building offers 500 study spaces with modern amenities and great natural light.",
        "Check evening availability: IB and Kaneff Centre classrooms often become quiet study spaces after classes end.",
        "Use CSW when campus is full: Virtual study rooms offer unlimited capacity when physical spaces are crowded."
      ]}
    />
  );
};

export default UofTMississauga;
